<template>
  <b-card class="my-3 shadow rounded">
    <form>
      <p v-if="error" class="alert alert-danger p-3">{{ error }}</p>
      <v-select
        id="drug"
        v-model="form.drug"
        v-b-tooltip.hover="'Select the drug to be dosed'"
        placeholder="Select Drug ..."
        :options="drugOptions"
        :disabled="disabled"
        required
        @update:model-value="clearSim"
      >
      </v-select>
      <br />
      <v-select
        v-if="form.drug"
        id="model"
        v-model="form.model"
        v-b-tooltip.hover="
          'Select the population PK model — each model uses different patient parameters and was derived from a specific patient population'
        "
        placeholder="Select Model ..."
        :options="modelOptions"
        :disabled="disabled"
        required
        @update:model-value="saveModel"
      >
      </v-select>
    </form>
  </b-card>
</template>

<script setup lang="ts">
import { ref, computed, watch } from 'vue';
import { drug_models } from '@/models/modelData/DrugModels.ts';
import { useDosingStore } from '@/stores/dosing';

defineOptions({ name: 'DrugSelect' });

const props = defineProps<{ selectedModel?: any }>();
defineEmits<{ (e: 'clearPatient', evt: any, id: any): void }>();

const store = useDosingStore();
const error = ref<string | null>(null);

function initForm() {
  const selectedDrug = store.getDrug;
  const drug = selectedDrug ? { label: selectedDrug.name, code: selectedDrug.id } : null;
  const model = props.selectedModel
    ? { label: props.selectedModel.name, code: props.selectedModel.code }
    : null;
  return { drug, model };
}

const form = ref(initForm());

watch(
  () => props.selectedModel,
  () => {
    form.value = initForm();
  },
);

const drugOptions = computed(() => drug_models.map((d: any) => ({ label: d.name, code: d.id })));

const selectedDrug = computed(() =>
  form.value.drug ? drug_models.find((d: any) => d.id === form.value.drug.code) : null,
);

const modelOptions = computed(() =>
  selectedDrug.value
    ? selectedDrug.value.models.map((m: any) => ({ label: m.name, code: m.code }))
    : [],
);

const disabled = computed(() => store.isReady);

function saveModel() {
  store.saveDrug(selectedDrug.value);
  store.saveModel(form.value.model.code);
}

function clearSim() {
  store.switchDrug(selectedDrug.value);
}
</script>

<style scoped></style>
